import React from 'react'
import { v4 as uuid } from 'uuid';
import { H3 } from 'components/texts'
import { Grid, Stack } from '@mui/material'
import { useIdiomaDataFormLogic } from 'hooks'
import { Line } from 'components/data_display'
import ProgressSheetTable from './parts/ProgressSheetTable'
import { Checkbox, Input } from 'components/forms/components'
import { ItemsSelect } from 'components/forms/components/Select/custom'

/**
 * Formulario para gestionar la información de idiomas de un grupo de academia.
 * Este componente permite seleccionar el libro principal usado en el grupo y muestra información del libro asociado si existe uno.
 * Además, incluye opciones para usar un libro asociado y para indicar si se utiliza una hoja de progreso.
 * Es un formulario interactivo que reacciona a los cambios del usuario y actualiza dinámicamente su contenido.
 *
 * @param {Object} props - Los props del componente.
 * 
 * @param {Object} props.grupo - Información del grupo actual.
 * @param {Function} props.register - Método para registrar los campos de formulario.
 * @param {Object} props.errors - Objeto con los errores de validación de los campos.
 * @param {Boolean} props.wantToReset - Indica si se desea reiniciar el formulario.
 * @param {Function} props.setValue - Método para establecer el valor de un campo.
 * @param {Function} props.onChangeLibro - Callback ejecutado al cambiar el libro seleccionado.
 * 
 * @returns {JSX.Element} - El formulario renderizado para la gestión de idiomas del grupo.
 */
export default function IdiomaGrupoAcademiaDataForm({ grupo, register, errors, wantToReset, setValue, onChangeLibro }) {
    const { libroAsociado, loadingLibroAsociado, handleChangeLibro, updateSelect, libroAsociadoCheck } = useIdiomaDataFormLogic({ onChangeLibro, grupo })

    return (
        <Grid container py={5}>
            <Grid container spacing={2} px={5}>
                <Grid item xs={6}>
                    <ItemsSelect
                        label={"Libro principal"}
                        name={"libro_id"}
                        keyValue={"libro"}
                        register={register}
                        errors={errors}
                        wantToReset={wantToReset}
                        defaultValue={grupo?.libro_id ?? ""}
                        onChange={handleChangeLibro}
                        updateValue={updateSelect}
                        searcheable />
                </Grid>
                <Grid item xs={6}>
                    <Input key={uuid()} label={"Libro asociado"} defaultValue={loadingLibroAsociado ? "Obteniendo información del libro asociado..." : (libroAsociado?.nombre ?? "")} disabled={true} className={"w-100"} />
                </Grid>
            </Grid>

            <Grid container spacing={2} px={5}>
                <Grid item xs={6} />

                <Grid item xs={6}>
                    <Checkbox
                        ref={libroAsociadoCheck}
                        name={"usar_libro_asociado"}
                        label={"Usa libro asociado"}
                        setValue={setValue}
                        register={register}
                        defaultChecked={grupo?.usar_libro_asociado ? true : false}
                        disabled={libroAsociado ? false : true} />
                </Grid>
            </Grid>

            <Grid container my={3} px={5}>
                <Line />
            </Grid>

            <Grid container px={5}>
                <Grid item xs={12}>
                    <Stack>
                        <H3>Progress sheet</H3>
                        <Checkbox name={"usar_progress_sheet"} label={"Se usa Progress Sheet"} register={register} defaultChecked={grupo?.usar_progress_sheet ? true : false} />
                    </Stack>
                </Grid>

                <ProgressSheetTable />
            </Grid>
        </Grid>
    )
}